import NotificationsIcon from '@mui/icons-material/Notifications';
import {
  Badge,
  Box,
  Icon,
  IconButton,
  InputBase,
  Switch,
  TextField,
} from '@mui/material';
import { styled } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  ACTION_CLOSE_NOTIFICATION_DRAWER,
  ACTION_DARK_MODE,
  ACTION_OPEN_NOTIFICATION_DRAWER,
} from '../../../component/MainUIFrame/constants';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../../component/MainUIFrame/MainFrame';
import SearchIcon from '@mui/icons-material/Search';
import {
  setAnchorEl,
  setPopoverFrom,
  setTemplate,
} from '../../../redux/features/popoverSlice';
import { SECTION_NOTIFICATIONS } from '../../../constants/sections/sectionConstants';
import { NotificationTemplate } from '../../../component/reusableUiComponent/NotificationTemplate';
import _ from 'lodash';
import { setCurrentUserSettings } from '../../../redux/features/currentSlice';
import { setProgress } from '../../../redux/features/progressSlice';
import { ehrAPIService } from '../../../http-common';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

// const SearchIconWrapper = styled("div")(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   height: "100%",
//   position: "absolute",
//   pointerEvents: "none",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// }));

// const StyledInputBase = styled(InputBase)(({ theme }) => ({
//   color: "inherit",
//   "& .MuiInputBase-input": {
//     padding: theme.spacing(1, 1, 1, 0),
//     // vertical padding + font size from searchIcon
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create("width"),
//     width: "100%",
//     [theme.breakpoints.up("sm")]: {
//       width: "12ch",
//       "&:focus": {
//         width: "20ch",
//       },
//     },
//   },
// }));

const EHRBottomBar = props => {
  const reduxDispatch = useDispatch();
  const dispatch = useMainFrameDispatch();
  const { isDark, isNotificationDrawerOpen } = useMainFrameState();
  const notificationList = useSelector(
    state => state?.notification?.notificationList
  );
  const currentUserPayload = useSelector(
    state => state?.current?.currentUserSettings?.resource
  );

  const updateUserSetting = async settings => {
    let setting = {
      theme: settings?.theme,
      language: settings?.language,
    };
    let payload = structuredClone(currentUserPayload);
    if (payload) {
      payload.extension = [
        {
          url: 'http://enliv.com/settings/data',
          valueString: JSON.stringify(setting),
        },
      ];
      try {
        reduxDispatch(setProgress(true));
        const response = await ehrAPIService.put(`updateResource`, payload);
        const rawData = { ...response?.data };
        const displaySetting = rawData?.extension?.find(
          item => item?.url === 'http://enliv.com/settings/data'
        )?.valueString;
        reduxDispatch(
          setCurrentUserSettings({
            resource: { ...rawData },
            display: JSON?.parse(displaySetting),
          })
        );
      } catch (e) {
        console.error(e);
      } finally {
        reduxDispatch(setProgress(false));
      }
    }
  };

  const handleThemeChange = () => {
    debugger;
    // dispatch({ type: ACTION_DARK_MODE })
    if (isDark) {
      updateUserSetting({ theme: 'light', language: 'english' });
    } else {
      updateUserSetting({ theme: 'dark', language: 'english' });
    }
  };

  return (
    <Box
      id="bottom_bar"
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <TextField
        label="search"
        sx={{
          visibility: 'hidden',
        }}
      />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box sx={{ cursor: 'pointer' }}>
          <Badge
            onClick={event => {
              if (isNotificationDrawerOpen) {
                dispatch({
                  type: ACTION_CLOSE_NOTIFICATION_DRAWER,
                });
              } else {
                dispatch({
                  type: ACTION_OPEN_NOTIFICATION_DRAWER,
                });
              }
            }}
            badgeContent={notificationList?.length}
            color="secondary"
          >
            <NotificationsIcon color="action" />
          </Badge>
        </Box>
        <Box>
          <Icon>setting</Icon>
          <IconButton onClick={handleThemeChange}>
            {isDark ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default EHRBottomBar;
